const LocalStorageConfig = {
    STORAGE_KEY:'free-rider-jumps-data'
}

export default LocalStorageConfig;